// extracted by mini-css-extract-plugin
export default {"container":"HeaderMainTitle_container__1x6mQ"};